/** DATE lobby = the Friends lobby with two seats (owner 22.9.2026: "Date Friendsin kanssa"); see Lobby.tsx */
import type { PublicPlayer } from '@snw/protocol';
import type { Expression } from '../ui/bits';
import { Lobby } from './Lobby';

export function LobbyDate({ code, expr }: { code: string; expr: (p: PublicPlayer) => Expression }) { return <Lobby code={code} expr={expr} date />; }
